import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CTSyncMapGridService } from '@cloud-twin-v2/ct-map/services/ct-sync-map-grid.service';
import { GridSetting } from '@common-modules/shared/constants/grid.constants';
import { GridConfiguration } from '@common-modules/shared/grid/grid-configuration';
import { LocalGridComponent } from '@common-modules/wlm-grid/local-grid/local-grid.component';

@Component({
  selector: 'ct-type-attribute-grid',
  templateUrl: './ct-type-attribute-grid.component.html',
  styleUrl: './ct-type-attribute-grid.component.scss',
  standalone: false,
})
export class CtTypeAttributeGridComponent implements OnInit, AfterViewInit {
  @ViewChild(LocalGridComponent) grid: LocalGridComponent;

  @Input() gridSettings: GridSetting;
  @Input() data: any;

  private _type: string;
  public get type(): string {
    return this._type;
  }
  @Input() public set type(value: string) {
    this._type = value;
    this.gridName = `${value.trim()}grid`;
  }

  private _gridConfiguration: GridConfiguration;
  get gridConfiguration(): GridConfiguration {
    return this._gridConfiguration;
  }
  @Input() set gridConfiguration(value: GridConfiguration) {
    this._gridConfiguration = value;
    if (value) {
      this.onGridConfigurationChangue.emit(value);
    }
  }

  @Output() onGridConfigurationChangue = new EventEmitter<GridConfiguration>();

  private readonly _ctSyncMapGridService = inject(CTSyncMapGridService);

  gridName: string;

  constructor(private _cdr: ChangeDetectorRef) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this._cdr.detectChanges();
  }

  onSelectedItem(element: any[]) {
    this._ctSyncMapGridService.setGridElements(element);
  }
}
